import React, { useState } from "react";
import ButtonV2 from "../../shared/components/buttonV2";
import { faqData } from "../../constants";
import { Fade } from "react-awesome-reveal";
import { FAQ_BTN } from "../../assets";

function Faqs() {
  const [openedFaq, setOpenedFaq] = useState(0);
  return (
    <div
      id="faq"
      className="flex lg:flex-row flex-col gap-y-5 items-start lg:space-x-7 justify-between py-10 lg:px-20 px-5"
    >
      <div className="lg:w-[550px] w-full flex flex-col lg:items-start items-center  gap-y-4">
        <div className="w-[229px] h-[37px] rounded-3xl text-globalGold bg-lightGold text-sm font-medium flex justify-center items-center">
          Frequently Asked Questions
        </div>
        <span className="text-primary-300 font-semibold lg:text-start text-center lg:text-[32px] text-2xl lg:leading-[40px] leading-[30px]">
          Some frequently asked questions <br className="lg:flex hidden" /> by
          our users
        </span>
        <span className="text-primary-50 font-medium text-[16px]  lg:text-start text-center">
          Find answers to common questions about Lis Pendens Anambra. For
          additional support, check our Help Center or contact our support team
          directly.
        </span>
      </div>
      <div className="lg:w-[650px] w-full h-full bg-lightGold rounded-lg p-7">
        <div className="w-full flex flex-col gap-y-4 max-h-96 overflow-y-auto">
          {faqData.map((item, faqIndex) => (
            <div className="w-full flex flex-col gap-y-4 bg-white  rounded-lg p-4">
              <div className="flex items-center justify-between w-full">
                <span className="lg:text-[16px] text-sm font-medium text-primary-300">
                  {faqIndex + 1}. {item.question}
                </span>

                <img
                  src={FAQ_BTN}
                  className={`w-[32px] h-[32px] cursor-pointer ${
                    openedFaq === faqIndex ? "rotate-360" : "rotate-180"
                  } transition-all duration-300`}
                  onClick={() => {
                    openedFaq === faqIndex
                      ? setOpenedFaq(0)
                      : setOpenedFaq(faqIndex);
                  }}
                  alt=""
                />
              </div>
              {openedFaq === faqIndex && (
                <Fade
                  direction="down"
                  duration={1000}
                  className="lg:text-sm text-xs font-medium text-primary-50"
                >
                  {item.answer}
                </Fade>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Faqs;
